import { FC } from "react";
import styles from "./card.module.scss";

type CardContentProps = {
  children: React.ReactNode;
}

export const CardContent: FC<CardContentProps> = ({ children } ) => {
  return (
    <div className={styles.cardContent}>
      {children}
    </div>
  );
}
